







































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';


@Component({
  components: {
  },
})
export default class SchemaEditor extends Vue {

  @Prop() private deviceType: any;
  @Prop() private tabDisplay!: number;

  private ready: boolean = false;
  private schemaView: any = {};
  private fieldTypes: string[] = ['int', 'float', 'boolean', 'string'];
  private fieldName: string = '';
  private preventClose: boolean = false;
  private originalSchema: any = {};
  private linkType: string = 'uplink';
  private tabChanged: boolean = false;

  private schemaError: string = '';

  @Watch('deviceType.schema_fields')
  public onChangeData(): void {
    this.getSchemaDataInHierarchy();
  }

  @Watch('tabDisplay', {immediate: true})
  public onTabChange(): void {
    this.tabChanged = true;
    switch (this.tabDisplay) {
      case 1:
        this.linkType = 'uplink';
        break;
      case 2:
        this.linkType = 'downlink';
        break;
      default:
        this.linkType = 'uplink';
    }

  }

  public get uppercase() {
    return this.linkType.charAt(0).toUpperCase() + this.linkType.slice(1);
  }

  public async mounted() {
    await this.initialRun();
  }

  private initialRun() {
    this.originalSchema = this.deviceType.schema_fields;
    this.schemaError = '';
    this.getSchemaDataInHierarchy();
  }

  private getSchemaDataInHierarchy() {
    const input = this.deviceType.schema_fields;

    const getVueData = (dbInput: []) => {
      const newShape: any = {};
      dbInput.forEach((row: any) => {
        if (!newShape[row.direction]) {
          newShape[row.direction] = [];
        }
        let newMessageName = newShape[row.direction].find((message: any) => message.messageName === row.message_type);
        if (!newMessageName) {
          const newArrayLength = newShape[row.direction].push({messageName: row.message_type, fields: []});
          newMessageName = newShape[row.direction][newArrayLength - 1];
        }
        const field = {
          id: row.id,
          device_version_id: row.device_version_id,
          message_type: row.message_type,
          fieldName: row.fieldName,
          type: row.type,
          direction: row.direction,
          description: row.description,
        };
        newMessageName.fields.push(field);
      });

      if (!newShape.uplink) {
        newShape.uplink = [{messageName: '', fields: [{

            device_version_id: this.deviceType.id,
            message_type: '',
            fieldName: '',
            type: 'int',
            direction: 'uplink',
            description: '',
          }]}];
      }
      if (!newShape.downlink) {
        newShape.downlink = [{messageName: '', fields: [{
            device_version_id: this.deviceType.id,
            message_type: '',
            fieldName: '',
            type: 'int',
            direction: 'downlink',
            description: '',
          }]}];
      }

      Vue.set(this, 'schemaView', newShape);
    };

    if (input) {
      getVueData(input);
      this.ready = true;
    }
  }

  private convertVueToData() {
    const inputVue = this.schemaView;
    const rows: any[] = [];
    Object.values(inputVue).forEach((direction: any) => {
      direction.forEach((message: any) => {
        message.fields.forEach((field: any) => {
          const fieldMessageType = message.messageName;
          const fieldName = field.fieldName;
          const fieldType = field.type;
          const fieldDirection = field.direction;
          const fieldId = field.id;
          const fieldDeviceId = field.device_version_id;
          const fieldDescription = field.description;

          if (fieldName.indexOf(' ') <= 0 || fieldMessageType.indexOf(' ') <= 0) {
            rows.push({
              id: fieldId,
              device_version_id: fieldDeviceId,
              message_type: fieldMessageType,
              // tslint:disable-next-line
              fieldName: fieldName,
              type: fieldType,
              direction: fieldDirection,
              description: fieldDescription,
            });
          }
        });
      });
    });

    this.validateAndSave(rows);
    return rows;
  }

  private validateAndSave(output: any) {
    let isValid: boolean = false;
    const originalSchema = JSON.stringify(this.originalSchema);
    isValid = output.every((field: any) => (((field.message_type && field.fieldName) || (!field.message_type && !field.fieldName)) && !((field.message_type && !field.fieldName) || (!field.message_type && field.fieldName))));
    const schemas = output.filter((field: any) => field.fieldName && field.message_type);
    if (isValid) {
      if (originalSchema !== JSON.stringify(schemas)) {
        this.$emit('saveSchema', schemas);
      }
    }
  }

  private validateField(event: any) {
    if (event.indexOf(' ') > 0) {
      this.preventClose = true;
    } else if (event.length > 100 && event.length < 0) {
      this.preventClose = true;
    }
  }

  private async removeMessageType(k: number, direction: string) {
    const filtered = this.schemaView[direction].filter((entry: any, index: number) => index !== k);

    Vue.set(this.schemaView, direction, filtered);
  }

  private addNewMessageType(direction: string) {
    let newMessages: any = {};
    newMessages = Object.assign({}, {messageName: '', fields: [{
        device_version_id:  this.deviceType.id,
        message_type: '',
        fieldName: '',
        type: 'int',
        // tslint:disable-next-line
        direction: direction,
        description: '',
      }]});

    Vue.set(this.schemaView[direction], this.schemaView[direction].length , newMessages);
  }

  private async addFields(fields: any, direction: string, messageType: string) {
    fields.push({
      device_version_id:  this.deviceType.id,
      message_type: messageType,
      fieldName: '',
      type: 'int',
      // tslint:disable-next-line
      direction: direction,
      description: '',
    });
  }
  private async removeFields(j: number, direction: any, k: number, fields: any) {
    const filtered = fields.filter((field: any, index: number) => {
      return index !== j;
    });
    Vue.set(this.schemaView[direction][k], 'fields', filtered);
  }
}
